import { render, staticRenderFns } from "./ConceptSuggestion.vue?vue&type=template&id=7db6477b&"
import script from "./ConceptSuggestion.vue?vue&type=script&lang=ts&"
export * from "./ConceptSuggestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports